import Weatherapp from "./Components/Weatherapp"
import './Components/Weatherapp.css'

const App = () => {
  return (
    <div>
      <Weatherapp />
    </div>
  )
}

export default App